export default "__VITE_ASSET__42ddee2e__"